import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'
import { Paper, Button } from '@mui/material'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, FormProvider } from 'react-hook-form'
import type { FieldValues } from 'react-hook-form'
import Stack from 'ui/layout/Stack'
import validationSchema from 'ui/shorthands/validationSchema'
import MarginRightCancelButton from 'ui/shorthands/MarginRightCancelButton'
import ApplicantAddressInputForm from 'ui/organisms/ApplicantAddressInputForm'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    margin: 'auto',
    width: '100%',
  },
  firstInput: {
    paddingRight: theme.spacing(2),
  },
  items: {
    padding: theme.spacing(1, 0),
  },
}))

export type ChangeAddressFormProps = {
  applicant_postal_code: string
  applicant_address: string
}

export type ChangeAddressModalContentProps = {
  defaultValues: ChangeAddressFormProps
  onSubmit: (data: ChangeAddressFormProps) => Promise<void>
  onClose: () => void
}

const ChangeAddressModalContent: React.FC<ChangeAddressModalContentProps> = ({
  defaultValues,
  onSubmit,
  onClose,
}: ChangeAddressModalContentProps) => {
  const { t } = useTranslation()
  const { classes } = useStyles()

  const schema = yup.object().shape({
    applicant_postal_code: validationSchema.postalCode().required(),
    applicant_address: validationSchema.text().required(),
  })

  const formMethods = useForm<FieldValues>({
    defaultValues,
    resolver: yupResolver(schema),
    mode: 'onChange',
  })
  const {
    handleSubmit,
    formState: { isValid, isSubmitting, isDirty },
  } = formMethods

  return (
    <Paper className={classes.root}>
      <form
        onSubmit={handleSubmit((data) =>
          onSubmit(data as ChangeAddressFormProps)
        )}
      >
        <div className={classes.items}>
          <FormProvider {...formMethods}>
            <ApplicantAddressInputForm />
          </FormProvider>
        </div>
        <Stack align={'right'} borderTop>
          <MarginRightCancelButton onClick={onClose} />
          <Button
            color="primary"
            variant="contained"
            type="submit"
            disabled={!isValid || !isDirty || isSubmitting}
          >
            {t('保存')}
          </Button>
        </Stack>
      </form>
    </Paper>
  )
}

export default ChangeAddressModalContent
